import api from "../api";
import {createError, logError, logSuccess} from "./message";
import types from "./types";

function deleteRequestRequest() {
  return {
    type: types.DELETE_REQUEST_PROGRAM_REQUEST,
    isDeletingRequestProgram: true
  };
}

function deleteRequestCompleted(deletedRequest) {
  return {
    type: types.DELETE_REQUEST_PROGRAM_COMPLETED,
    isDeletingRequestProgram: false,
    deletedRequest
  };
}

function deleteRequestError(deleteRequestError) {
  return {
    type: types.DELETE_REQUEST_PROGRAM_ERROR,
    isDeletingRequestProgram: false,
    deleteRequestError
  };
}

export function deleteRequest(requestId) {
  return dispatch => {
    dispatch(deleteRequestRequest());
    return api.deleteRequestProgram(requestId)
      .then(response => {
        if (response.status === 200) {
          dispatch(deleteRequestCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(deleteRequestError(message));
        } else {
          logError(err);
          dispatch(deleteRequestError(createError("Не удалось удалить заявку")));
        }
      });
  };
}

export default {
  deleteRequest
};
